module.exports = __webpack_public_path__ + "static/media/howToScheme.f8697c19.png";